export enum ResultsDeliveryType {
  REAL_TIME = "REAL_TIME",
  DONT_SHARE = "DONT_SHARE",
  THREADED = "THREADED",
}
